import { FileTextOutlined } from "@ant-design/icons";
import { textCore } from "./core/text";
import { defineWidget } from "../widgetDefinition";
import { NoSlots } from "../Slots";
import { NoControlPanel, NoDuplication, NoInfo } from "../widgetContract";
import type { TextComponentSpec } from "../Processing/types";
import { TextWidget } from "../WidgetComponents/TextWidget";
import { TextConfigurator } from "../AddWidgetModal/TextConfigurator";

export const textDefinition = defineWidget<TextComponentSpec>({
  ...textCore,
  type: "text",
  slots: NoSlots,
  duplicate: NoDuplication,
  controlPanel: NoControlPanel,
  info: NoInfo,
  schema: ["display"],
  contractHash: "1v9l8o7dliy",

  template: {
    label: "Text",
    description: "Formatted text block for notes and summaries",
    icon: <FileTextOutlined />,
  },

  defaultLayout: { w: 4, h: 4, minW: 2, minH: 2 },

  gridComponent: ({ id }) => <TextWidget id={id} />,

  configurator: {
    modalTitle: "Text Widget",
    wide: true,
    Component: TextConfigurator as any,
  },
});
